import { useState, useEffect } from 'react';
const useScreenDimensions = () => {
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    useEffect(() => {
        if (width === 0) {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        }
        const handleResize = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return { width, height };
};
export default useScreenDimensions;
